import { apiClient, type CustomKeySettingEntity } from '@/libs/api'

export type FetchCustomKeySettingsQuery = {
  tenantKey: string
  dcId: number
}

/**
 * 拠点のカスタムキー一覧取得 API（#3463 VOC_PJ-829/851）。
 * 拠点あたり5件（slotNumber 1-5）固定で返却される。
 */
export const fetchCustomKeySettings = async (
  { tenantKey, dcId }: FetchCustomKeySettingsQuery,
  signal?: AbortSignal
): Promise<CustomKeySettingEntity[]> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .dcs._dcId(dcId)
    .custom_key_settings.$get({ config: { signal } })
  return data
}
